import { Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Button as SuperAdminButton } from '../../../../baseComponents';
import { SuperAdminTable } from '../../../../baseComponents/Table';

type RuleRow = {
  key: string;
  id: string;
  name: string;
  event: string;
};

type RulesetTabProps = {
  hasOrgSelected: boolean;
  onAddRule: () => void;
  ruleRows: RuleRow[];
  ruleEditorColumns: any;
  isLoadingCurrentRuleSet: boolean;
  isFetchingCurrentRuleSet: boolean;
  hasUnsavedRuleChanges: boolean;
  isSavingRuleSet: boolean;
  onSaveRuleSet: () => void;
};

const SuperAdminButtonBase = SuperAdminButton as any;
const SuperAdminTableBase = SuperAdminTable as any;

export const RulesetTab = ({
  hasOrgSelected,
  onAddRule,
  ruleRows,
  ruleEditorColumns,
  isLoadingCurrentRuleSet,
  isFetchingCurrentRuleSet,
  hasUnsavedRuleChanges,
  isSavingRuleSet,
  onSaveRuleSet,
}: RulesetTabProps) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <SuperAdminButtonBase
          type="button"
          onClick={onAddRule}
          disabled={!hasOrgSelected}
        >
          <PlusOutlined className="mr-2" /> Add Rule
        </SuperAdminButtonBase>
      </div>
      <div className="ant-table rounded-xl shadow-xl">
        <SuperAdminTableBase
          className="appointment-page-table"
          data={ruleRows}
          columns={ruleEditorColumns}
          loading={isLoadingCurrentRuleSet || isFetchingCurrentRuleSet}
        />
      </div>
      <div className="flex justify-end">
        <div className="flex items-center gap-3">
          <Typography.Text
            type={hasUnsavedRuleChanges ? 'warning' : 'secondary'}
          >
            {hasUnsavedRuleChanges ? 'Unsaved changes' : 'All changes saved'}
          </Typography.Text>
          <SuperAdminButtonBase
            type="button"
            onClick={onSaveRuleSet}
            disabled={
              !hasOrgSelected || isSavingRuleSet || !hasUnsavedRuleChanges
            }
          >
            {isSavingRuleSet ? 'Saving...' : 'Save Ruleset'}
          </SuperAdminButtonBase>
        </div>
      </div>
    </div>
  );
};
